import { Component, Input } from '@angular/core';
import { AuthService, DatasourceService } from '@app/core/services';
import { BaseListComponent } from './base-list.component';
import { State, aggregateBy, AggregateResult } from "@progress/kendo-data-query";
import { IntlService } from '@progress/kendo-angular-intl';


@Component({
  selector: 'vehicles-entries-list',
  template: `
  <kendo-grid [style.height.%]="100" [data]="view | async">

    <ng-template kendoGridNoRecordsTemplate>
      Sin registros.
    </ng-template>

    <kendo-grid-column field="n" title="#" width="60" [filterable]="false">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        # {{rowIndex + 1}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="entry_date" title="Fecha" width="120" *ngIf="view_date">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
        <kendo-grid-cell-date [text]="dataItem[(this.type == 'ENTRY') ? 'entry_date': 'output_date']" [time]="false"></kendo-grid-cell-date>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="sku_exp" title="Folio de expediente" width="100" [style]="{'text-align': 'right'}"></kendo-grid-column>    
    <kendo-grid-column field="authority_abbreviation" title="Autoridad">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem">   
        {{dataItem.authority_abbreviation}} - {{dataItem.authority_name}}
      </ng-template>
    </kendo-grid-column>
    <!--<kendo-grid-column field="sku_inv" title="Folio de inventario" width="100" [style]="{'text-align': 'right'}"></kendo-grid-column>-->
    <kendo-grid-column field="marck" title="Marca" width="120"></kendo-grid-column>
    <kendo-grid-column field="color" title="Color" width="120"></kendo-grid-column>
    <kendo-grid-column field="plaque" title="Placas" width="120"></kendo-grid-column>    
    <kendo-grid-column field="deposit_name" title="Depósito" width="120"></kendo-grid-column>
    <kendo-grid-column field="vehicle_type_name" title="Tipo de Vehículo" width="{{(type == 'ENTRY') ? 340: 220}}">
      <ng-template kendoGridFooterTemplate *ngIf="type != 'ENTRY'">
        <div style="text-align: right; {{(type == 'OUTPUT_CREDIT') ? 'color: #3aabf0': ''}}" *ngIf="type != 'ENTRY'">Total</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="cost_paid" title="Pagado" width="120" format="{0:c}" [style]="{'text-align': 'right'}" *ngIf="type != 'ENTRY'">
      <ng-template kendoGridFooterTemplate>
        <div style="text-align: right; {{(type == 'OUTPUT_CREDIT') ? 'color: #3aabf0': ''}}">{{intl.formatNumber(total?.cost_paid?.sum, 'c2')}}</div>
      </ng-template>
    </kendo-grid-column>    

  </kendo-grid>
  `,
  styles: [``],
  providers:  [ DatasourceService ]
})
export class VehiclesListComponent extends BaseListComponent {

  //Variables

  protected table: string = 'vehicles_inventories';

  //Input: range
  public _range = { start: '', end: '' };

  @Input()
  set range(range: any) {
    this._range = range;
    
    let that = this;
    this.state = this.getInitialState();
    this.service.pagination(this.table, this.state, function(result, table, state){
      console.log(result, table, state);
      // that.visible = result.data.length;
      that.total = aggregateBy(result.data, [
        { field: "cost_paid", aggregate: "sum" }
      ]); 
      
      if(Object.keys(that.total).length === 0) 
        that.total = {cost_paid: {sum: 0}};
    
      that.resultChange.emit({name: `VEHICLES_${that.type}_${that.payment_type}`, result: result, sum: that.total.cost_paid.sum});

    })

  }

  get range(): any { return this._range; }

  @Input() type: string = 'ENTRY';

  @Input() payment_type: string = '';

  @Input() view_date: boolean = true;

  public total: AggregateResult;

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected intl: IntlService) {

    super(authService, service, intl);
    console.log(this.range);

  }

  //Overrides
  protected getInitialState() : State {

    let target: string = (this.type == 'ENTRY') ? 'entry_date': 'output_date';

    let s : State = {
      skip: 0, 
      take: 0, 
      sort: [      
        {field: 'sku_exp', dir: 'desc'}
      ], 
      filter: {
        logic: "and",
        filters: [               
          {
            field: target,
            operator: 'inrange',
            // value: `${this._date} 00:00:00,${this._date} 23:59:59`
            value: `${this._range.start} 00:00:00,${this._range.end} 23:59:59`
          }
        ]
      }, 
      group: []
    }

    if(this.type == 'OUTPUT') {
      
      s.filter.filters.push(
        {
          field: 'id_payment_type',
          operator: 'in',
          value: this.payment_type
        }
      )
      
    }

    if(this.type == 'OUTPUT_CREDIT') {
      
      s.filter.filters.push(
        {
          field: 'id_vehicle_status',
          operator: 'eq',
          value: 4
        }
      )
      
    }

    return s;

  }
  
}
